export default __webpack_public_path__ + "static/media/rightarrow.17fb81fc.svg";